<template>
  <div id="app">
    <router-view></router-view>
    <el-backtop>
      <div class="backTop">
        <i class="el-icon-top"></i>
        <div>回顶部</div>
      </div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: function () {
      // console.log(to,from)
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="less">
@import "./assets/less/base.less";
@import "./assets/less/public.less";
#app {
  font-family: MicrosoftYaHei, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: @base-fontsize;
  color: @color-default;
  background-color: #f5f5f5;
  .backTop {
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    text-align: center;
    line-height: 1.5;
    color: #707070;
    border-radius: 8px;
    font-size: 16px;
    padding: 10px;
    i {
      font-size: 30px;
    }
  }
  .el-backtop {
    width: 70px;
    height: auto;
    border-radius: 0;
    border: 1px solid #e9e9e9;
    box-shadow: none;
    // background: #ffffff;
  }
}
</style>
